import request from '@/utils/request'

// 获取品牌列表
export const getBrands = (params) => {
  return request({
    url: '/api/brands',
    method: 'get',
    params
  })
}

// 创建品牌
export const createBrand = (data) => {
  return request({
    url: '/api/brands',
    method: 'post',
    data
  })
}

// 更新品牌
export const updateBrand = (id, data) => {
  return request({
    url: `/api/brands/${id}`,
    method: 'put',
    data
  })
}

// 删除品牌
export const deleteBrand = (id) => {
  return request({
    url: `/api/brands/${id}`,
    method: 'delete'
  })
}

// 切换品牌状态
export const toggleBrandStatus = (id, data) => {
  return request({
    url: `/api/brands/${id}/status`,
    method: 'patch',
    data
  })
}